import React, { useEffect, useMemo, useRef } from 'react';
import './style.less';
import { useAppSelector } from 'shared/store';
import { Icon } from 'shared/components/Icon';
import UserAvatar from 'shared/components/UserAvatar';
import { VisitorAvatar } from 'shared/components/VisitorAvatar';
import { selectActiveUser } from 'shared/store/shared-selectors';
import { formatDuration } from 'shared/utils/helpers';

export const ConnectedCallDetailTranscript: React.FC = () => {
  const { detailTask: dialTask } = useAppSelector(s => s.outbound);
  const user = useAppSelector(selectActiveUser);
  const { liveTranscriptions: transcriptions } = useAppSelector(s => s.transcription);

  const transcription = useMemo(() => {
    if (!dialTask?.id) return [];

    const result = transcriptions?.[dialTask.id] ?? {};

    return Object.values(result);
  }, [dialTask?.id, transcriptions]);

  const transcriptContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (transcriptContainerRef.current) {
      // Get the last transcript item
      const lastTranscriptItem = transcriptContainerRef.current
        .lastElementChild as HTMLElement;

      /* @ts-ignore */
      lastTranscriptItem?.scrollIntoViewIfNeeded();
    }
  }, [transcription]);

  return (
    <div className="ConnectedCallDetailTranscript">
      <div className="ConnectedCallDetailTranscript__header">
        <Icon icon="heartbeat" />
        Transcript
      </div>
      <div ref={transcriptContainerRef} className="ConnectedCallDetailTranscript__body">
        <>
          {!transcription.length && (
            <div className="ConnectedCallDetailTranscript__empty">
              No transcript available
            </div>
          )}
          {transcription
            ?.sort((a, b) => a.startTime - b.startTime)
            .map(t => {
              return (
                <div className="ConnectedCallDetailTranscript__item" key={t.id}>
                  <div className="ConnectedCallDetailTranscript__sender">
                    {t.channel === 'outbound' ? (
                      <>
                        <UserAvatar
                          user={user}
                          className="ConnectedCallDetailTranscript__avatar"
                          size={40}
                        />
                        {user?.displayName}
                      </>
                    ) : (
                      <>
                        <VisitorAvatar
                          visitor={{
                            id: (dialTask?.contact?.id as unknown) as string,
                            customMetadata: {
                              ...(dialTask?.contact?.customMetadata ?? {}),
                            },
                            displayName: `${dialTask?.contact?.firstName} ${dialTask?.contact?.lastName}`,
                          }}
                          size={24}
                        />
                        {dialTask?.contact?.firstName} {dialTask?.contact?.lastName}
                      </>
                    )}

                    <span className="ConnectedCallDetailTranscript__timestamp">
                      {formatDuration(t.startTime)}
                    </span>
                  </div>
                  <div className="ConnectedCallDetailTranscript__message">
                    {t.transcript}
                  </div>
                </div>
              );
            })}
        </>
      </div>
    </div>
  );
};
